const tabbar = [
    "personal", "Inventory", "my", 'home', 'menuPage', 'messageList', 'demo'
]
export default tabbar